export class TranRecordModel {
    Seq: number;
    SupSeq: number;
    PetNo: number;
    ClientNo: number;
    ClinicNo: number;
    LinkNo: number;
    LinkType: number;
    LinkName: string | null;
    ReturnLinkName: boolean;
    LinkDesc: string | null;
    IndicationID: number | null;
    Category: string | null;
    LinkFix: string | null;
    Unit: number | null;
    UnitCost: number | null;
    Unit_Measure: string | null;
    Dosage: number | null;
    Route: string | null;
    Location: string | null;
    Frequency: string | null;
    Days: number | null;
    ReqDate: string;
    ReqBy: number | null;
    ReqName: string | null;
    ApproveDate: string | null;
    ApproveBy: number | null;
    ApproveName: string | null;
    DoneDate: string | null;
    DoneBy: number | null;
    DoneName: string | null;
    InvDate: string | null;
    InvBy: number | null;
    InvName: string | null;
    Status: string;
    PStatus: boolean | null;
    Tax: number;
    Response1: string | null;
    Response2: string | null;
    Approval: string | null;
    CheckCost: string | null;
    Cost: number | null;
    SubCost: number;
    IType: string | null;
    Printed: boolean | null;
    WTime: string | null;
    Moved: boolean | null;
    RecallDate: string | null;
    IsOptional: boolean | null;
    IsRerequest: any;
    Supervisor: number;
    Attending: number | null;
    BaseChg: string | null;
    Notes: string | null;
    // True only for rows TreatGen/TreatGenEst generated as a recurring-treatment
    // occurrence. Status "R" alone isn't a reliable signal - ordinary requests (e.g. a
    // regular prescription) also sit at "R" before being marked Done.
    is_treatment: boolean;
    // frontend-only
   
    constructor() {
        this.Seq = 0;
        this.SupSeq = 0;
        this.PetNo = 0;
        this.ClientNo = 0;
        this.ClinicNo = 0;
        this.LinkNo = 0;
        this.LinkType = 0;
        this.LinkName = null;
        this.ReturnLinkName = false;
        this.LinkDesc = null;
        this.IndicationID = null;
        this.Category = null;
        this.LinkFix = null;
        this.Unit = null;
        this.UnitCost = null;
        this.Unit_Measure = null;
        this.Dosage = null;
        this.Route = null;
        this.Location = null;
        this.Frequency = null;
        this.Days = null;
        this.ReqDate = '0001-01-01T00:00:00';
        this.ReqBy = null;
        this.ReqName = null;
        this.ApproveDate = null;
        this.ApproveBy = null;
        this.ApproveName = null;
        this.DoneDate = null;
        this.DoneBy = null;
        this.DoneName = null;
        this.InvDate = null;
        this.InvBy = null;
        this.InvName = null;
        this.Status = '';
        this.PStatus = null;
        this.Tax = 0;
        this.Response1 = null;
        this.Response2 = null;
        this.Approval = null;
        this.CheckCost = null;
        this.Cost = null;
        this.SubCost = 0;
        this.IType = null;
        this.Printed = null;
        this.WTime = null;
        this.Moved = null;
        this.RecallDate = null;
        this.IsOptional = null;
        this.IsRerequest = null;
        this.Supervisor = 0;
        this.Attending = null;
        this.BaseChg = null;
        this.Notes = null;
        this.is_treatment = false;
    }
}
